/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-useless-fragment */
import CrossIcon from "components/RevampFeedDetails/assets/CrossIcon";
import CrossWithBGIcon from "components/RevampFeedDetails/assets/CrossWithBGIcon";
import React from "react";

const ApplicationStatusBottomSheet = ({ content, open, handleClose }) => {
	if (open)
		return (
			<div className="sticky bottom-0 left-0 z-20 h-auto w-full">
				{/* Mobile close section */}
				<div
					className="flex cursor-pointer items-center justify-end px-[16px] py-[12px] md:hidden"
					onClick={handleClose}
				>
					<CrossWithBGIcon />
				</div>
				{/* Desktop close section */}
				<div
					className="hidden items-center justify-end rounded-t-[8px] bg-white px-[16px] pt-[12px] md:flex"
					onClick={handleClose}
				>
					<div className="cursor-pointer">
						<CrossIcon fill="#190A28" size="24" />
					</div>
				</div>
				<div className="rounded-t-[8px] bg-white pt-[16px] md:rounded-t-none">
					{content}
				</div>
			</div>
		);
	return <></>;
};

export default ApplicationStatusBottomSheet;
